import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/common/SEO';
import FAQSection from '../components/common/FAQSection';

function WebScraper() {
  return (
    <>
      <SEO pathname="/agents/web-scraper" agentKey="WebScraper" />

    <main className="agent-page" style={{ paddingTop: '80px', minHeight: '100vh', background: 'var(--color-bg-light)', color: 'var(--color-text-primary)' }}>
      <section style={{ padding: '60px 0', background: 'linear-gradient(180deg, rgba(0,0,0,0.02) 0%, transparent 100%)' }}>
        <div className="container">
          <div style={{ marginBottom: '2rem' }}>
            <Link to="/" style={{ color: 'var(--color-primary)', textDecoration: 'none', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <span>←</span> Back to Home
            </Link>
          </div>
          
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '48px', alignItems: 'center' }}>
            <div className="waas-card" style={{ flex: '1', minWidth: '300px', maxWidth: '400px', margin: '0', background: 'white', padding: '40px', borderRadius: '24px', boxShadow: 'var(--shadow-xl)', border: '1px solid rgba(0,0,0,0.05)', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: '-50px', right: '-50px', width: '150px', height: '150px', background: 'var(--color-primary)', filter: 'blur(80px)', opacity: '0.2', borderRadius: '50%' }}></div>
              <div className="waas-icon-container" style={{ margin: '0 auto 24px auto', width: '140px', height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-bg-subtle)', borderRadius: '50%' }}>
                 <img src="/images/icons/logo_worker.webp" alt="Web Scraper" width="100" height="100" style={{ objectFit: 'contain' }} />
              </div>
              <h1 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '8px', color: '#1d1d1f' }}>Web Scraper</h1>
              <p style={{ textAlign: 'center', color: 'var(--color-text-secondary)', marginBottom: '24px', fontSize: '1.1rem' }}>Enterprise AI Agent</p>
              
              <div style={{ background: 'rgba(0,113,227,0.1)', color: 'var(--color-primary)', padding: '8px 16px', borderRadius: '100px', display: 'inline-block', fontWeight: '600', fontSize: '0.9rem', width: '100%', textAlign: 'center', marginBottom: '16px' }}>
                ● Status: Soon
              </div>
              
              <a href="https://app.eagentix.com/register" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ width: '100%', textAlign: 'center', display: 'block', padding: '16px 0', fontSize: '1.1rem', textDecoration: 'none' }}>
                Deploy Agent
              </a>
            </div>

            <div style={{ flex: '2', minWidth: '400px' }}>
              <span className="section-label">Digital Workforce Persona</span>
              <h2 style={{ fontSize: '3rem', marginBottom: '24px', color: '#1d1d1f', fontWeight: '700', lineHeight: '1.2' }}>Web Scraper</h2>
              <p style={{ fontSize: '1.25rem', color: '#424245', marginBottom: '24px', lineHeight: '1.6' }}>
                Crawls websites to extract market intelligence automatically.
              </p>
              <div style={{ padding: '24px', background: 'white', borderRadius: '16px', border: '1px solid rgba(0,0,0,0.05)' }}>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '12px' }}>Core Responsibilities</h3>
                <ul style={{ paddingLeft: '20px', color: 'var(--color-text-secondary)', lineHeight: '1.6' }}>
                  <li>Autonomous task execution based on natural language instructions.</li>
                  <li>Seamless integration with existing enterprise communication channels and data systems.</li>
                  <li>Continuous learning and adaptation to organizational workflows.</li>
                  <li>Strict adherence to SOC2 and enterprise governance guardrails.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FAQSection agentKey="WebScraper" />
    </main>
    </>
  );
}

export default WebScraper;
